import axios from 'axios';
import { buildLoginUrl } from '@common/helpers/loginRedirect';

export const getHeaders = (headers = {}) => {
    return {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'is-api-query': true,
        "X-Requested-With": "XMLHttpRequest",
        ...headers,
    }
};

export const getTimeout = () => {
    return 30000; // 30 seconds
};

// Shared 401 redirect — mirrors `core/middleware/authRedirectMiddleware`
// for code paths that talk to the backend via axios (v5 / transcription
// account buttons, ad-hoc fetches) instead of redux-api-middleware. One
// behavior for every API surface: a 401 ALWAYS means "session is gone,
// send the user to /customer/ and bring them back" — no per-call
// `if (err.status === 401) location.href = …` boilerplate scattered
// across components. 403 is intentionally NOT caught here (see the
// redux middleware comment for the rationale).
let redirecting = false;

function redirectToCustomerLogin() {
    if (redirecting) return;
    redirecting = true;
    // Shared builder (mirrors the server + redux-middleware): keeps the
    // returnUrl readable (`/ ? =` raw) and guards the /customer/ loop.
    window.location.assign(buildLoginUrl());
}

export const xhrRequest = axios.create({
    baseURL: location.origin,
    headers: getHeaders(),
    withCredentials: false,
    timeout: getTimeout(),
});

xhrRequest.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error && error.response && error.response.status === 401) {
            redirectToCustomerLogin();
        }
        return Promise.reject(error);
    },
);